import { render } from "./ShiftedVertical.vue?vue&type=template&id=98d552b4&scoped=true&ts=true"
import script from "./ShiftedVertical.vue?vue&type=script&lang=ts"
export * from "./ShiftedVertical.vue?vue&type=script&lang=ts"

import "./ShiftedVertical.vue?vue&type=style&index=0&id=98d552b4&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d552b4"]])

export default __exports__